module.exports = __webpack_public_path__ + "img/64_8.4ef3ef2a.png";